// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".range{flex-grow:1}.filter-rating{display:flex;align-items:center}.filter-rating .rating-icon{width:24px;height:24px;margin-bottom:8px}", ""]);
// Exports
module.exports = exports;
